import { iconArrowDropDown } from "ui/components/icons";
import AppIcon from "ui/components/icons/AppIcon";
import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
import { alpha } from "@mui/material/styles";
import React from "react";

interface ProfileButtonProps {
  username: string;
  menuId: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const ProfileButton: React.FC<ProfileButtonProps> = ({
  username,
  menuId,
  onClick,
}) => (
  <Button
    aria-controls={menuId}
    aria-haspopup="true"
    onClick={onClick}
    color="inherit"
    style={{
      height: "100%",
      letterSpacing: "1.25px",
      fontSize: "16px",
      minWidth: "10em",
      justifyContent: "center",
    }}
  >
    {username ? (
      <span>{username}</span>
    ) : (
      <Skeleton
        width="6em"
        height="2em"
        sx={{
          backgroundColor: (theme) => alpha(theme.palette.common.white, 0.25),
        }}
        data-test-id="profile-button-skeleton"
      />
    )}
    <AppIcon icon={iconArrowDropDown} data-test-id="profile-button-icon" />
  </Button>
);

export default ProfileButton;
